up.compiler('[autofocus]', (element) => {
  window.queueMicrotask(() => {
    // [autofocused] are instantly focused by the browser when they are rendered
    // We have to emit the "focusin" event manually that your compilers can still
    // react to it.
    up.emit(element, 'focusin')
  })
})
